export default "__VITE_ASSET__DOVeuIC9__"